import { configureStore, createSlice } from "@reduxjs/toolkit";
import catalogApi from "../services/catalog";
import subscriptionApi from "../services/subscription";
import subsListApi from "../services/subsList";
import userApi from "../services/user";
import { IMIThemeMode } from "../utils/ImiUtilData";

const homeSlice = createSlice({
  name: "home",
  initialState: {
    count: 1,
    canGoBack: false,
    //userToken:"eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJLYWxhbmEiLCJhdXRob3JpdGllcyI6WyJST0xFX0RFViJdLCJpYXQiOjE2MjAzNzcxODEsImV4cCI6MTY1MTkxMzE4MSwidWQiOiI1ZDFjOTU5OS1mY2M3LTQ2ZDMtYmQ2YS1hZjhiMmJmNjQxOWUiLCJ0eXBlIjoiQUNDRVNTIn0.gsQbBX3ALI9dKSD2qMDcw18-z-AQu_WHvBjxqHVdzxM",
    userToken: null,
    userData: null,
    themeMode: IMIThemeMode.DARK,
    activeUrlData: null,
    activeGameUUID: null,
    activeSubScreen: null,
    isNavBarsHidden: false,
  },
  reducers: {
    increase: (state) => {
      state.count++;
    },
    decrease: (state) => {
      state.count--;
    },
    setUserToken: (state, action) => {
      state.userToken = action.payload;
    },
    setUserData: (state, action) => {
      if (action.payload) {
        state.userData = {
          name: action.payload.name,
          image: action.payload.image,
        };
      } else {
        state.userData = null;
      }
    },
    activateBack: (state, action) => {
      state.canGoBack = action.payload;
    },
    changeTheme: (state, action) => {
      state.themeMode = action.payload;
    },
    setActiveUrlData: (state, action) => {
      state.activeUrlData = {
        isGame: action.payload.isGame,
        url: action.payload.url,
      };
    },
    setActiveGameUUID: (state, action) => {
      state.activeGameUUID = action.payload;
    },
    //NOT SUBSCRIPTION SCREEN
    setActiveSubScreen: (state, action) => {
      state.activeSubScreen = action.payload;
    },
    setNavBarStatus: (state, action) =>{
      state.isNavBarsHidden=action.payload;
    }
  },
});

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

//remove feedBackApi!!
const store = configureStore({
  reducer: {
    home: homeSlice.reducer,
    [catalogApi.reducerPath]: catalogApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [subsListApi.reducerPath]: subsListApi.reducer,
    [subscriptionApi.reducerPath]: subscriptionApi.reducer,
  },
  //CACHING WILL BE HANDLED BY THE MIDDLEWARE
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(catalogApi.middleware)
      .concat(userApi.middleware)
      .concat(subsListApi.middleware)
      .concat(subscriptionApi.middleware),
});

//only for debugging and as an example for thunk, Remove!!!
export const waitFor = (time) => {
  return async (dispatch) => {
    await delay(time);
    dispatch(homeActions.decrease());
  };
};

export const homeActions = homeSlice.actions;

export default store;
